import React, { LegacyRef } from 'react';
interface Props {
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  navPage?: boolean;
  appBar?: React.ReactNode;
  contentClassName?: string;
  contentStyle?: React.CSSProperties;
  contentRef?: LegacyRef<HTMLDivElement> | undefined;
}
export default function Page({
  className,
  navPage,
  appBar,
  contentClassName,
  style,
  contentStyle,
  children,
  contentRef,
}: Props) {
  return (
    <div className={`page ${navPage ? 'nav-page' : ''} ${className}`} style={style}>
      {appBar}
      <div ref={contentRef} className={contentClassName} style={contentStyle}>
        {children}
      </div>
    </div>
  );
}
